import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_th428x9zzy: FaireBrandEntity = {
  token: "b_th428x9zzy",
  type: "brand",
  name: "Woon",
  avatarUrl:
    "https://cdn.faire.com/fastly/0981e205be34aaf02c5f0a19d40f6ac86e4eff4315c95894f537e951dc87f903.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fd97794a204625fcf4b4b9de9ea2d5cb8a86b3faced572ee1baad1a56e5fbb2e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0981e205be34aaf02c5f0a19d40f6ac86e4eff4315c95894f537e951dc87f903.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fd97794a204625fcf4b4b9de9ea2d5cb8a86b3faced572ee1baad1a56e5fbb2e.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 31,
  isTopShop: true,
  isInsider: true,
  description:
    "Woon began as a family run pop-up born from a desire to share our mother's (Mama Fong) original Chinese comfort food. We offer a simple menu and pantry goods influenced by Shanghainese and Cantonese recipes. \n\nWhen we moved away from home it was always Mama’s cooking that we craved. We all worked full-time jobs and hosted pop-ups in the Los Angeles area when we could. Now, we have our first brick and mortar space located in Historic Filipinotown, Los Angeles and a new location coming soon to Pasadena.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:43.074Z",
    importedBy: "entity-db-cli",
  },
};
